import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearnHarmony = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.6,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 9,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 9,
			r: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M2 20c0-3.3 2.7-6 6-6s6 2.7 6 6M10 20c0-3.3 2.7-6 6-6s6 2.7 6 6" })
	]
});
export default SvgLearnHarmony;
